import { ModalContext } from 'app/app';
import axios from 'axios';
import { FieldInput } from 'components/fieldInput';
import { ViewContext, useNavigate } from 'components/lib';
import { Form, Formik } from 'formik';
import { Fragment, useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import image from './images/loader.gif';
import styles from './styles.module.scss';
import { RunQuotePopup } from 'components/RunQuotePopup';

export function RunQuoteModal(props) {
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [runWithProgressive, setRunWithProgressive] = useState(false);

  const firstValidationSchema = Yup.object().shape({
    company: Yup.string().required('This field is required!'),
  });

  const handleContinue = () => {
    setModalOpen(false);
    if (formValues) {
      submitFormValues(formValues, runWithProgressive);
    }
  };

  const handleCancel = () => {
    setModalOpen(false);
  };

  async function runAPI() {
    await axios
      .get(`/api/company/list/all`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        context.notification.show(
          'Failed to load companies',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  useEffect(() => {
    runAPI();
  }, []);

  const submitFormValues = async (values, runWithProgressive) => {
    setLoading(true);

    const selectedCompany = data.find((o) => o.id === values.company);

    const apiEndpoint = runWithProgressive
      ? '/app/progressive/quote/run'
      : '/app/quote/run';

    navigate(apiEndpoint, {
      state: {
        data: {
          company_id: selectedCompany.id,
        },
      },
    });

    setLoading(false);
    setModal({});
  };

  return (
    <Fragment>
      {modal.name === 'run_quote_modal' && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Run Quote</div>
              <div className={styles.line} />
              <Formik
                validationSchema={firstValidationSchema}
                initialValues={{
                  company: data && data.length > 0 ? data[0].id : '',
                }}
                onSubmit={(values) => {
                  setFormValues(values);
                  setModalOpen(true);
                }}
              >
                {({
                  errors,
                  touched,
                  values,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={handleSubmit}
                    >
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="company"
                          type="select"
                          label="Company"
                          placeholder="Company"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.company}
                          touched={touched.company}
                          required
                          options={data.map((value) => ({
                            value: value.id,
                            label: value.name,
                          }))}
                        />
                      </div>
                    </Form>
                    <div className={styles.footer}>
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal('')}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          style={
                            !loading
                              ? { cursor: 'pointer' }
                              : { cursor: 'default' }
                          }
                          onClick={() => {
                            setRunWithProgressive(false);
                            !loading && submitForm();
                          }}
                        >
                          {loading ? (
                            <img
                              src={image}
                              alt="loading"
                              style={{ width: '25px' }}
                            />
                          ) : (
                            'Run'
                          )}
                        </button>
                        {/*                         <button
                          className={styles.saveP}
                          style={
                            !loading
                              ? { cursor: "pointer" }
                              : { cursor: "default" }
                          }
                          onClick={() => {
                            setRunWithProgressive(true);
                            !loading && submitForm();
                          }}
                        >
                          {loading ? (
                            <img
                              src={image}
                              alt="loading"
                              style={{ width: "25px" }}
                            />
                          ) : (
                            "Run with Progressive"
                          )}
                        </button> */}
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
      {isModalOpen && (
        <RunQuotePopup
          onContinue={handleContinue}
          onCancel={handleCancel}
        />
      )}
    </Fragment>
  );
}
